// ── CACHE BUST ──────────────────────────────────────
const CACHE_VERSION = '2';
if (sessionStorage.getItem('cacheVersion') !== CACHE_VERSION) {
  sessionStorage.clear();
  sessionStorage.setItem('cacheVersion', CACHE_VERSION);
}

// ── INTRO VIDEO ──────────────────────────────────────
const video        = document.getElementById('intro-video');
const poster       = document.getElementById('intro-poster');
const enterOverlay = document.getElementById('enter-overlay');
const intro        = document.getElementById('intro');
const store        = document.getElementById('store');

if (video && poster && intro && store) {
  let started  = false;
  let canEnter = false;

  if (window.innerWidth <= 768) {
    const mobileSrc = video.dataset.mobileSrc;
    if (mobileSrc) video.src = mobileSrc;
    const mobilePoster = poster.dataset.mobileSrc;
    if (mobilePoster) poster.src = mobilePoster;
  }

  function showFallback() {
    poster.classList.add('visible');
    setTimeout(() => {
      enterOverlay.classList.add('visible');
      canEnter = true;
    }, 400);
  }

  function startVideo() {
    if (started) return;
    started = true;
    const p = video.play();
    if (p !== undefined) p.catch(showFallback);
  }

  function enterStore() {
    if (!canEnter) return;
    canEnter = false;
    sessionStorage.setItem('introDone', '1');
    sessionStorage.setItem('introTime', Date.now().toString());
    intro.classList.add('fade-out');
    setTimeout(() => {
      intro.style.display = 'none';
      store.classList.add('visible');
      document.body.style.overflow = 'auto';
    }, 800);
  }

  const now = Date.now();
  const introDone = sessionStorage.getItem('introDone');
  const introTime = parseInt(sessionStorage.getItem('introTime') || '0');
  const isRecent = introDone && (now - introTime) < 1800000;

  if (isRecent) {
    intro.style.display = 'none';
    store.classList.add('visible');
    document.body.style.overflow = 'auto';
  } else {
    startVideo();
    document.addEventListener('click', () => { startVideo(); if (canEnter) enterStore(); });
    document.addEventListener('keydown', startVideo);
    video.addEventListener('ended', showFallback);
    window.addEventListener('wheel', () => { if (canEnter) enterStore(); });
    let touchStartY = 0;
    window.addEventListener('touchstart', e => { touchStartY = e.touches[0].clientY; }, { passive: true });
    window.addEventListener('touchend', e => {
      if (touchStartY - e.changedTouches[0].clientY > 50 && canEnter) enterStore();
    }, { passive: true });
    enterOverlay.addEventListener('click', enterStore);
  }

  const navLogo = document.querySelector('.nav-logo');
  if (store && navLogo) {
    store.addEventListener('scroll', () => {
      const y = store.scrollTop;
      navLogo.style.opacity   = y > 40 ? '0' : '1';
      navLogo.style.transform = y > 40 ? 'translateY(-8px)' : 'translateY(0)';
      navLogo.style.pointerEvents = y > 40 ? 'none' : 'auto';
    }, { passive: true });
  }
}

// Hamburger menu
function toggleMenu() {
  const links = document.querySelector('.links');
  if (links) links.classList.toggle('open');
}

// Scroll reveal
const io = new IntersectionObserver(es => {
  es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } });
}, { threshold: .12 });
document.querySelectorAll('.rv').forEach((el, i) => {
  el.style.transitionDelay = (i % 4 * 70) + 'ms';
  io.observe(el);
});

// ── SHOPIFY CART ──────────────────────────────────────
function openCart() {
  fetchCart();
  document.getElementById('cart-sidebar').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
}

function closeCart() {
  document.getElementById('cart-sidebar').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
}

function fetchCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const countEl = document.querySelector('.cart-count');
      if (countEl) countEl.textContent = cart.item_count;
      const totalEl = document.getElementById('cart-total-price');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      const itemsEl = document.getElementById('cart-items');
      if (!itemsEl) return;
      if (cart.items.length === 0) {
        itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        return;
      }
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <img src="${item.image}" alt="${item.title}">
          <div class="cart-item-info">
            <p class="cart-item-title">${item.title}</p>
            <p class="cart-item-variant">${item.variant_title || ''}</p>
            <div class="cart-item-row">
              <div class="cart-item-qty">
                <button onclick="updateCart('${item.key}', ${item.quantity - 1})">−</button>
                <span>${item.quantity}</span>
                <button onclick="updateCart('${item.key}', ${item.quantity + 1})">+</button>
              </div>
              <span class="cart-item-price">${formatMoney(item.line_price)}</span>
            </div>
          </div>
        </div>
      `).join('');
    });
}

function updateCart(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  }).then(() => fetchCart());
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ── CHECKOUT REDIRECT TO INSTAGRAM ──────────────────────────────────────
let activePopup = null;

function closePopup() {
  if (activePopup) {
    activePopup.remove();
    activePopup = null;
  }
}

function checkoutRedirect() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      let orderDetails = 'Hola! Quiero ordenar:\n\n';
      cart.items.forEach(item => {
        orderDetails += '📦 ' + item.title + '\n';
        if (item.variant_title) orderDetails += '📏 Talla: ' + item.variant_title + '\n';
        orderDetails += '💰 ' + formatMoney(item.line_price) + '\n';
        orderDetails += '🔢 Cantidad: ' + item.quantity + '\n\n';
      });
      orderDetails += '💵 Total: ' + formatMoney(cart.total_price);

      const instagramUser = 'grindpuertorico';
      const message = encodeURIComponent(orderDetails);

      const popup = document.createElement('div');
      popup.id = 'checkout-popup';
      popup.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;background:rgba(0,0,0,0.85);display:flex;align-items:center;justify-content:center;padding:24px;';

      popup.innerHTML = `
        <div style="background:#111;border:1px solid rgba(250,250,250,.1);padding:40px 32px;max-width:420px;width:100%;text-align:center;">
          <p style="font-family:'JetBrains Mono',monospace;font-size:9px;letter-spacing:.3em;color:#555;text-transform:uppercase;margin-bottom:16px;">Aviso</p>
          <h3 style="font-family:'Anton',sans-serif;font-size:26px;color:#FAFAFA;letter-spacing:.05em;margin-bottom:16px;line-height:1.1;">PROBLEMAS TÉCNICOS</h3>
          <p style="font-family:'Inter',sans-serif;font-size:13px;line-height:1.8;color:#8A8781;margin-bottom:16px;">Debido a problemas técnicos temporales no podemos procesar tu orden aquí. Serás redirigido a nuestro Instagram para completar tu compra.</p>
          <p style="font-family:'Anton',sans-serif;font-size:20px;color:#FAFAFA;letter-spacing:.08em;margin-bottom:32px;">$5 OFF POR LA MOLESTIA.</p>
          <a href="https://ig.me/m/${instagramUser}?text=${message}" target="_blank" style="display:block;padding:16px;background:#FAFAFA;color:#0A0A0A;font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:.3em;text-transform:uppercase;text-decoration:none;margin-bottom:12px;">IR A INSTAGRAM →</a>
          <button onclick="closePopup()" style="background:none;border:none;font-family:'JetBrains Mono',monospace;font-size:9px;letter-spacing:.2em;color:#555;cursor:pointer;text-transform:uppercase;padding:8px 16px;">CANCELAR</button>
        </div>
      `;

      activePopup = popup;
      document.body.appendChild(popup);
    });
}

window.openCart = openCart;
window.closeCart = closeCart;
window.checkoutRedirect = checkoutRedirect;
window.updateCart = updateCart;
window.closePopup = closePopup;